/* After Five - collection and search pages (workstream C).
   1. "Load more": the button is a real link to the next page; here it fetches that page's
      section and appends its products in place, and puts them back after a Back navigation
      that reloaded the page.
   2. Grid density toggle (section setting, off by default): one button in the filter bar that
      switches between the two views, choice kept in localStorage, applied with a class on
      <html> and matching image sizes. */
(function () {
  if (window.afCollection) return;
  window.afCollection = true;

  function listOf(doc) {
    var grid = doc.getElementById('product-grid');
    if (!grid) return null;
    return grid.tagName === 'UL' ? grid : grid.querySelector('ul.product-grid');
  }

  /* ---- 1. Load more ---- */
  var STORE = 'afLoadMore:';
  var loaded = []; /* next-page URLs appended on this page view, in order */

  function storeKey() {
    return STORE + window.location.pathname + window.location.search;
  }

  /* Fetches the page behind a "Load more" link and appends its products. Resolves true when done. */
  function appendFrom(link, opts) {
    var list = listOf(document);
    var wrap = link.closest('[data-af-pagination]');
    if (!list || !wrap || !window.fetch || !window.DOMParser) return Promise.reject(new Error('unsupported'));
    link.setAttribute('aria-disabled', 'true');
    link.classList.add('loading');

    var href = link.href;
    var url = new URL(href, window.location.href);
    var sectionId = document.getElementById('product-grid').getAttribute('data-id');
    if (sectionId) url.searchParams.set('section_id', sectionId);

    return fetch(url.toString())
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextList = listOf(doc);
        if (!nextList) throw new Error('no product grid in response');
        var fragment = document.createDocumentFragment();
        var firstNew = null;
        Array.prototype.slice.call(nextList.children).forEach(function (item) {
          if (item.classList.contains('af-vs-reel-item')) return; /* the reel belongs to the first page */
          item.classList.remove('scroll-trigger', 'animate--slide-in');
          if (!firstNew) firstNew = item;
          fragment.appendChild(item);
        });
        list.appendChild(fragment);

        var nextWrap = doc.querySelector('[data-af-pagination]');
        if (nextWrap) {
          /* The fetched status describes its own page ("Showing 49 to 57 of 57"); this page now
             holds everything from the item it started with. */
          var oldStatus = wrap.querySelector('[data-af-first]');
          var status = nextWrap.querySelector('[data-af-first]');
          var first = (oldStatus && parseInt(oldStatus.getAttribute('data-af-first'), 10)) || 1;
          if (status) {
            var shown = parseInt(status.getAttribute('data-af-shown'), 10);
            var total = parseInt(status.getAttribute('data-af-total'), 10);
            status.setAttribute('data-af-first', first);
            /* The sentence comes from the locale file, printed by snippets/pagination.liquid with
               its numbers left open */
            var text = status.getAttribute(first > 1 ? 'data-af-text-range' : 'data-af-text-showing');
            if (text) {
              status.textContent = text.replace('[first]', first).replace('[shown]', shown).replace('[total]', total);
            }
            var bar = nextWrap.querySelector('.af-load-more__bar > span');
            if (bar && total) {
              bar.style.marginLeft = ((first - 1) * 100 / total) + '%';
              bar.style.width = ((shown - first + 1) * 100 / total) + '%';
            }
          }
          wrap.replaceWith(document.importNode(nextWrap, true));
        } else {
          wrap.remove();
        }

        loaded.push(href);
        if (!(opts && opts.restoring)) {
          /* The card's title link, not the photo link before it (that one is hidden from assistive tech) */
          var focusTarget = firstNew && (firstNew.querySelector('.af-card__link') || firstNew.querySelector('a[href]'));
          if (focusTarget) focusTarget.focus({ preventScroll: true });
        }
        document.dispatchEvent(new CustomEvent('af:grid-updated', { detail: { source: 'load-more' } }));
        return true;
      });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-af-load-more]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;
    if (!listOf(document) || !link.closest('[data-af-pagination]') || !window.fetch || !window.DOMParser) return;
    event.preventDefault();
    if (link.getAttribute('aria-disabled') === 'true') return;
    appendFrom(link).catch(function () {
      window.location.href = link.href;
    });
  });

  /* Coming back with Back. Browsers that keep the page in memory restore it whole. Where they do
     not (in-app browsers, pages the cache refuses) the page reloads with its first 24 products and
     the shopper lands in the wrong place. So: on leaving, remember which pages "Load more" added
     and the scroll position; on a back / forward load, add them again and return there. */
  function remember() {
    try {
      if (!loaded.length) { sessionStorage.removeItem(storeKey()); return; }
      /* The place is kept as "this card, this far from the top of the screen": that holds even
         when the page above it is laid out a little differently next time (ratings arrive late) */
      var anchor = null;
      var links = document.querySelectorAll('#product-grid .af-card__link[id]');
      for (var i = 0; i < links.length; i++) {
        var card = links[i].closest('.af-card');
        var box = card && card.getBoundingClientRect();
        if (box && box.bottom > 0) { anchor = { id: links[i].id, top: Math.round(box.top) }; break; }
      }
      sessionStorage.setItem(storeKey(), JSON.stringify({ pages: loaded, y: Math.round(window.scrollY), anchor: anchor, t: Date.now() }));
    } catch (e) {}
  }

  function restore() {
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(storeKey()) || 'null'); } catch (e) {}
    var nav = window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (!saved || !nav || nav.type !== 'back_forward') {
      try { sessionStorage.removeItem(storeKey()); } catch (e) {}
      return;
    }
    if (!saved.pages || !saved.pages.length || Date.now() - saved.t > 30 * 60 * 1000) return;

    /* Leave the shopper alone as soon as she scrolls or types herself */
    var touched = false;
    function touch() { touched = true; }
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (type) {
      window.addEventListener(type, touch, { passive: true, once: true });
    });

    var queue = saved.pages.slice(0, 10);
    (function next() {
      var link = document.querySelector('[data-af-load-more]');
      if (!queue.length || !link || touched) return finish();
      var want = queue.shift();
      if (link.href !== want) return finish();
      appendFrom(link, { restoring: true }).then(next, finish);
    })();

    function finish() {
      var more = document.querySelector('[data-af-load-more]');
      if (more) { more.removeAttribute('aria-disabled'); more.classList.remove('loading'); }
      if (touched || !loaded.length) return;
      var link = saved.anchor && document.getElementById(saved.anchor.id);
      var card = link && link.closest('.af-card');
      if (card) window.scrollTo(0, card.getBoundingClientRect().top + window.scrollY - saved.anchor.top);
      else window.scrollTo(0, saved.y);
    }
  }

  window.addEventListener('pagehide', remember);
  /* A filter or sort change (assets/facets.js) replaces the grid and the URL with a fresh first
     page: what was loaded before no longer applies */
  document.addEventListener('af:grid-updated', function (event) {
    if (!event.detail || event.detail.source !== 'load-more') loaded = [];
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restore);
  else restore();

  /* ---- 2. Grid density ---- */
  var KEY = 'afGridDensity';
  var LARGE_SIZES =
    '(min-width: 2200px) 624px, (min-width: 1696px) 518px, (min-width: 1600px) calc((100vw - 144px) / 3), ' +
    '(min-width: 1536px) 712px, (min-width: 990px) calc((100vw - 112px) / 2), ' +
    '(min-width: 750px) calc((100vw - 80px) / 2), calc(100vw - 32px)';

  function density() {
    return document.documentElement.classList.contains('af-grid-large') ? 'large' : 'compact';
  }

  function syncSizes() {
    var large = density() === 'large';
    document.querySelectorAll('.af-product-grid .af-card__image').forEach(function (img) {
      if (!img.hasAttribute('data-af-sizes')) {
        if (!large) return;
        img.setAttribute('data-af-sizes', img.getAttribute('sizes') || '');
      }
      img.setAttribute('sizes', large ? LARGE_SIZES : img.getAttribute('data-af-sizes'));
    });
  }

  function syncButtons() {
    var mode = density();
    /* The one button: pressed = the large view is on (its icon follows the class on <html>). */
    document.querySelectorAll('[data-af-density-toggle]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(mode === 'large'));
    });
    document.querySelectorAll('[data-af-density-set]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.getAttribute('data-af-density-set') === mode));
    });
  }

  function initDensity() {
    if (!document.querySelector('[data-af-density]')) {
      document.documentElement.classList.remove('af-grid-large');
      return;
    }
    syncButtons();
    syncSizes();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-af-density-toggle], [data-af-density-set]');
    if (!button) return;
    var mode = button.hasAttribute('data-af-density-toggle')
      ? (density() === 'large' ? 'compact' : 'large')
      : button.getAttribute('data-af-density-set');
    document.documentElement.classList.toggle('af-grid-large', mode === 'large');
    try { localStorage.setItem(KEY, mode); } catch (e) {}
    syncButtons();
    syncSizes();
  });

  document.addEventListener('af:grid-updated', function () {
    if (document.querySelector('[data-af-density]')) syncSizes();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDensity);
  else initDensity();
})();
